import { CheckoutProvider } from "context/CheckoutContext";
import CheckOutPagePageMain from "./CheckOutPage";


function CheckoutIndex() {
    return (
        <CheckoutProvider>
            <CheckOutPagePageMain />
        </CheckoutProvider>
    )
}

export default CheckoutIndex

